import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { DocumentViewer, type DocumentItem } from '@odo/shared-ui';
import api from '../../api/config';

interface DocumentViewerModalProps {
    title: string;
    documents: DocumentItem[];
    onClose: () => void;
}

const DocumentViewerModal: React.FC<DocumentViewerModalProps> = ({ title, documents, onClose }) => {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="relative bg-white rounded-xl shadow-sm w-full max-w-5xl h-[85vh] p-6 flex flex-col"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between pb-4 border-b border-gray-100">
                    <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
                    <button
                        onClick={onClose}
                        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>
                <div className="flex-grow mt-4 overflow-hidden">
                    <DocumentViewer
                        documents={documents}
                        apiBaseUrl={api.defaults.baseURL ?? ''}
                        showControls
                        className="h-full"
                        getAuthToken={() => localStorage.getItem('odo_login_token')}
                    />
                </div>
            </div>
        </div>
    );
};

export default DocumentViewerModal;
